import { addManagerModalActionTypes } from './Constants';

const initialState = {
	open: false,
	loading: true,
	data: {
		total_count: 0,
		results: [],
	},
	groupId: null,
	instituteId: null,
	callback: null,
	appliedFilters: {},
	submitLoading: false,
};

export default function addGroupManagersModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case addManagerModalActionTypes.TOGGLE_ADD_MANAGER_MODAL:
			return {
				...state,
				...data,
			};
		case addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS:
			return {
				...state,
				loading: true,
			};
		case addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS_SUCCESS:
			return {
				...state,
				loading: false,
				data,
			};
		case addManagerModalActionTypes.GET_INSTITUTE_GROUP_TEACHERS_ERROR:
			return {
				...state,
				loading: false,
			};
		case addManagerModalActionTypes.CHANGE_ADD_MANAGER_MODAL_FILTERS:
			return {
				...state,
				appliedFilters: data.appliedFilters,
			};
		case addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS:
			return {
				...state,
				submitLoading: true,
			};
		case addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS_SUCCESS:
			return {
				...state,
				submitLoading: false,
				open: false,
			};
		case addManagerModalActionTypes.ADD_INSTITUTE_GROUP_TEACHERS_ERROR:
			return {
				...state,
				submitLoading: false,
			};
		case addManagerModalActionTypes.CLEAR_ADD_MANAGER_MODAL_STATE:
			return initialState;
		default:
			return state;
	}
}
